module.exports = __webpack_public_path__ + "img/avatar2_pl.d0fe1135.svg";